export const aboutPageData = {
  hero: {
    eyebrow: "Sobre a Dionara",
    description:
      "Dionara Krause atua com foco em nutrição clínica, saúde da mulher e emagrecimento com leveza, oferecendo um acompanhamento humano, individualizado e adaptado à realidade de cada paciente. Seu trabalho une ciência, estratégia e acolhimento para promover saúde, constância e uma relação mais equilibrada com a alimentação.",
    image: "/assets/images/about/dionara-hero.png",
    imageAlt: "Dionara Krause",
    titleLines: [
      "Nutrição com",
      "estratégia,",
      "acolhimento",
      "e mais leveza",
      "no processo.",
    ],
  },

  tabs: {
    sobre: {
      label: "Sobre mim",
      eyebrow: "Quem é a Dionara",
      title: "Uma profissional que acredita no cuidado com escuta, clareza e leveza.",
      lead:
        "Minha caminhada na nutrição nasceu do desejo de cuidar de pessoas de forma mais próxima, humana e verdadeira.",
      paragraphs: [
        "Sempre acreditei que saúde não deve ser tratada de forma rígida ou distante da realidade, mas sim com estratégia, acolhimento e respeito ao momento de cada pessoa.",
        "Ao longo da minha trajetória, fui construindo uma forma de atender que valoriza a individualidade, a escuta e a adaptação à rotina de quem está do outro lado.",
        "Hoje, meu trabalho reflete exatamente isso: um cuidado mais leve, individualizado e construído junto com cada paciente.",
      ],
    },

    carreira: {
      label: "Minha carreira",
      eyebrow: "Minha trajetória",
      title: "Uma trajetória construída com propósito, cuidado e evolução.",
      lead:
        "Minha trajetória profissional foi construída a partir do desejo de unir conhecimento técnico, escuta e acolhimento em um atendimento mais próximo da realidade de cada paciente.",
      paragraphs: [
        "Ao longo da minha formação e experiência, fui aperfeiçoando não apenas a parte técnica, mas também a forma de conduzir cada acompanhamento com clareza, leveza e individualidade.",
        "Hoje, meu trabalho reflete uma visão de cuidado que respeita a história, o tempo e o processo de cada pessoa.",
      ],
      items: [
        {
          title: "Formação",
          text: "Graduação em Nutrição, com base técnica voltada para um atendimento seguro, responsável e individualizado.",
        },
        {
          title: "Aprofundamento",
          text: "Interesse e desenvolvimento contínuo em nutrição clínica e comportamento alimentar.",
        },
        {
          title: "Atuação prática",
          text: "Atendimento personalizado, com foco em rotina real, leveza e constância.",
        },
        {
          title: "Momento atual",
          text: "Uma abordagem mais humana e estratégica, alinhada ao que realmente faz sentido para cada paciente.",
        },
      ],
    },

    trabalho: {
      label: "Como eu trabalho",
      eyebrow: "Minha forma de cuidar",
      title: "Cada atendimento é pensado para funcionar na vida real.",
      lead:
        "Meu atendimento é construído com escuta, estratégia e adaptação à realidade de cada paciente.",
      paragraphs: [
        "Não acredito em soluções prontas. Cada plano precisa fazer sentido para a rotina, os objetivos e o momento de quem está sendo cuidado.",
        "Mais do que orientar, meu objetivo é acompanhar, trazer clareza e construir um caminho possível, para que a evolução aconteça com segurança e leveza.",
        "Meu cuidado respeita a individualidade de cada paciente, sem perder direção, estratégia e acompanhamento próximo.",
      ],
    },

    valores: {
      label: "No que eu acredito",
      eyebrow: "Meus valores",
      title: "Os valores que orientam meu cuidado.",
      lead:
        "Minha forma de atender é guiada por princípios que tornam o processo mais humano, leve e conectado à realidade de cada paciente.",
      paragraphs: [
        "Acredito que saúde não precisa ser construída com extremos, rigidez ou culpa. O caminho mais sustentável é aquele que respeita o tempo, o contexto e a individualidade de cada pessoa.",
      ],
      items: [
        {
          title: "Cuidado individualizado",
          text: "Cada paciente tem uma história, uma rotina e necessidades próprias. Por isso, cada acompanhamento é pensado de forma única.",
        },
        {
          title: "Leveza no processo",
          text: "Saúde e alimentação não precisam ser sinônimo de culpa ou restrição. O caminho precisa ser possível de sustentar.",
        },
        {
          title: "Escuta e acolhimento",
          text: "Antes de orientar, é preciso entender. Aqui, cada paciente é escutada com atenção, respeito e empatia.",
        },
        {
          title: "Estratégia com realidade",
          text: "O plano precisa funcionar na rotina real, considerando objetivos, dificuldades, preferências e fase de vida.",
        },
        {
          title: "Estratégia com propósito",
          text: "Cada orientação precisa fazer sentido, ter direção clara e respeitar o momento de cada paciente.",
        },
        {
          title: "Equilíbrio",
          text: "Resultados sustentáveis são construídos com constância, cuidado e escolhas possíveis, não com extremos.",
        },
      ],
    },
  },

  quote: {
    text: "Acredito que saúde, bem-estar e autoestima devem caminhar juntos, de forma leve, humana e possível.",
    author: "Dionara Krause",
  },
};
